export const validation = {
  methods: {
    validation(target) {
      const email_pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const password_pattern = /^(?=.*\d)(?=.*[A-Z]).{8,}$/;
      const input_type = target.type;

      switch (input_type) {
        case 'email':
          if (!email_pattern.test(target.value)) {
            this.appendChild(target);
          } else {
            target.classList.remove('is-invalid');
          }
          break;
        case 'password':
          if (!password_pattern.test(target.value)) {
            this.appendChild(target);
          } else if (target.id === 'password_confirmation' && target.value !== this.user_info.password) {
            this.appendChild(target);
          } else {
            target.classList.remove('is-invalid');
          }
          break;
        case 'checkbox':
          if (!target.checked) {
            this.appendChild(target);
          } else {
            target.classList.remove('is-invalid');
          }
          break;
        default:
          if (target.value.length < 1) {
            this.appendChild(target);
          } else {
            target.classList.remove('is-invalid');
          }
          break;
      }
    },
    appendChild(target) {
      target.classList.add('is-invalid');
      let innerHTML = '';
      switch (target.type) {
        case 'email':
          innerHTML = '請輸入正確的電子郵件'
          break;
        case 'password':
          innerHTML = '密碼長度需大於八個字元，並包含大小寫英數字'
          break;
        case 'checkbox':
          innerHTML = '請勾選同意條款'
          break;
        default:
          innerHTML = '不得為空白';
          break;
      }
      if (target.id === 'password_confirmation') {
        innerHTML = '與輸入的密碼不符';
      }
      const error_div = this.errorMessage(target, innerHTML);
      target.parentNode.appendChild(error_div);

      // remove the error div after 3 seconds
      setTimeout(function () {
        error_div.parentNode.removeChild(error_div);
      }, 2000);
    },
    errorMessage(target, innerHTML) {
      const error_div = document.createElement('div');
      error_div.classList.add('invalid-feedback');
      error_div.id = 'error-' + target.id;
      error_div.style.position = 'absolute';
      error_div.style.bottom = '-1.1rem';
      error_div.style.left = '0';
      error_div.style.transition = '0.3s';
      error_div.innerHTML = innerHTML;

      return error_div;
    },
    validateBeforeSubmit(target) {
      this.$el.querySelectorAll('input').forEach(element => {
        this.validation(element);
      })

      return this.$el.querySelectorAll('.is-invalid').length === 0 ? true : false;
    },
  }
};
